import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import Box from 'components/Box';
import Heading from 'components/Heading';
import UserGeneratedText from 'components/UserGeneratedText';
import { Ranking } from 'components/ContentCards';
import { BASIC } from 'styles/spacingPresets';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CONTENT_MAX_WIDTH = 820;
function SectionBlock(_ref) {
  var section = _ref.section,
    hasPlaylistNumbering = _ref.hasPlaylistNumbering;
  var name = section.name,
    description = section.description,
    rank = section.rank;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      maxWidth: CONTENT_MAX_WIDTH,
      children: /*#__PURE__*/_jsxs(Heading, {
        as: "h2",
        children: [/*#__PURE__*/_jsx(Ranking, {
          rank: hasPlaylistNumbering ? rank : undefined
        }), name]
      })
    }), description && /*#__PURE__*/_jsx(Box, {
      maxWidth: CONTENT_MAX_WIDTH,
      mt: "xs",
      fontSize: BASIC.MEDIUM,
      breakpoints: BASIC.BREAKPOINTS,
      overflow: "wrap",
      children: /*#__PURE__*/_jsx(UserGeneratedText, {
        text: description
      })
    })]
  });
}
export default SectionBlock;